import React from "react";
import { Row, Col, Card } from "@pankod/refine-antd";
import { KpiCards } from "../charts/KpiCards";
import { DailyTrendLine } from "../charts/DailyTrendLine";
import { EventDistributionPie } from "../charts/EventDistributionPie";
import { TopProductsColumn } from "../charts/TopProductsColumn";

interface OverviewTabProps {
  dateRange: [string, string];
  shopCode: string | null;
}

export const OverviewTab: React.FC<OverviewTabProps> = ({
  dateRange,
  shopCode,
}) => {
  return (
    <>
      <KpiCards dateRange={dateRange} shopCode={shopCode} />

      <Row gutter={[16, 16]} style={{ marginTop: 16 }}>
        <Col xs={24} xl={16}>
          <Card title="Günlük Trend" style={{ height: "100%" }}>
            <DailyTrendLine dateRange={dateRange} shopCode={shopCode} />
          </Card>
        </Col>
        <Col xs={24} xl={8}>
          <Card title="Event Dağılımı" style={{ height: "100%" }}>
            <EventDistributionPie dateRange={dateRange} shopCode={shopCode} />
          </Card>
        </Col>
      </Row>

      <Row gutter={[16, 16]} style={{ marginTop: 16 }}>
        <Col xs={24}>
          <Card title="En Çok Tıklanan 10 Ürün">
            <TopProductsColumn
              dateRange={dateRange}
              shopCode={shopCode}
              limit={10}
            />
          </Card>
        </Col>
      </Row>
    </>
  );
};
